import React from "react";
import PageTemplate from "./Components/PageTemplate";
function App() {
  return (
    <div className="App">
     <PageTemplate />
    </div>
  );
}

export default App;
